import { createSvgIcon } from '../../createSvgIcon';

export const TextAreaIcon = createSvgIcon(
  <path d="M0 0H16V2H0V0ZM0 4H16V6H0V4ZM0 8H16V10H0V8ZM0 12H10V14H0V12Z" fill="currentColor" />,
  { displayName: 'TextAreaIcon', viewBox: '0 0 16 14' }
);
